export default __webpack_public_path__ + "static/squashlife-6d74ca360c90ff2b0b26e56f3c5067a8.png";